module.exports = __webpack_public_path__ + "img/face76.bc776309.gif";